import styled from 'styled-components';

import useDebounce from '@hooks/useDebounce';
import { Range } from 'react-range';

const Track = styled.div`
	height: 6px;
	background-color: #8c8b8b;
	${({ $disabled }) => $disabled && `filter: brightness(0.5)`};
`;

const Thumb = styled.div`
	height: 16px;
	width: 16px;
	border-radius: 50%;
	box-shadow: 0px 2px 6px #1c1c1c;
	background-color: ${({ theme }) => theme.colors.green};
	${({ $disabled }) => $disabled && `filter: grayscale(25%) contrast(75%)`};
`;

const IndexSlider = ({
	min = 0,
	max = 1,
	sliderRef,
	slideIndex,
	setSlideIndex,
	disabled = false,
}) => {
	// Debounce only the sliderRef update
	const debouncedSliderUpdate = useDebounce(index => {
		sliderRef.current.slickGoTo(index);
	}, 50);

	if (min === max) {
		return <div></div>;
	}

	const handleIndexSliderChange = index => {
		if (disabled) return;
		setSlideIndex(index);
		debouncedSliderUpdate(index);
	};

	return (
		<>
			<Range
				disabled={disabled}
				onChange={handleIndexSliderChange}
				min={min}
				max={max}
				step={1}
				values={slideIndex}
				renderTrack={({ props, children }) => (
					<Track
						{...props}
						style={{
							...props.style,
						}}
						$disabled={disabled}>
						{children}
					</Track>
				)}
				renderThumb={({ props }) => (
					<Thumb
						{...props}
						key={props.key}
						style={{
							...props.style,
						}}
						$disabled={disabled}
					/>
				)}
			/>
		</>
	);
};
export default IndexSlider;
